import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  todoDropdown: {
    minHeight: '48px'
  },
  deletePortfolioBtn: {
    padding: '4px 16px',
    '& div': {
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'left'
    }
  }
});
export default useStyles;